import type { ApiV1 } from '@teamworksdev/influencer/core';
import { TEAMWORKS_APP_SLUGS, type TeamworksAppSlug } from '@teamworksdev/vuetify';

export interface AppTargetUrl {
	slug: TeamworksAppSlug;
	url: string;
}

export interface NavbarStyle {
	bottomColor: string | null;
	topColor: string | null;
	imageUrl: string | null;
}

function isTeamworksAppSlug(slug: string): slug is TeamworksAppSlug {
	return Object.values(TEAMWORKS_APP_SLUGS).includes(slug as TeamworksAppSlug);
}

export class UserAxleProfile {
	name: string | null;
	profileUuid: string | null;
	appTargetUrls: AppTargetUrl[] = [];
	loginAccess: ApiV1.AppSwitcherLoginAccessProperties['login_access'];
	navbar: NavbarStyle = {
		bottomColor: null,
		imageUrl: null,
		topColor: null,
	};

	constructor(data: ApiV1.AppSwitcherUserProfile) {
		this.name = data.name;
		this.profileUuid = data.profile_uuid;
		this.navbar.bottomColor = data.navbar_bottom_color;
		this.navbar.topColor = data.navbar_top_color;
		this.navbar.imageUrl = data.navbar_image_url;
		this.loginAccess = data.login_access;

		// Include current app in target URLs
		this.appTargetUrls.push({
			slug: TEAMWORKS_APP_SLUGS.INFLCR,
			url: window.location.origin,
		});

		for (const key in data) {
			if (!key.endsWith('_target_url')) continue;

			const slug = key.replace('_target_url', '');
			if (!isTeamworksAppSlug(slug)) continue;

			const url = data[key as keyof typeof data];

			if (typeof url !== 'string') {
				continue;
			}

			if (!data.login_access.web[slug as keyof typeof data.login_access.web]) {
				continue;
			}

			this.appTargetUrls.push({ slug, url });
		}
	}
}
